import React, { Component } from 'react';
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';
import 'react-data-table-component-extensions/dist/index.css';
import { getAllAdClientsCloseLoop } from '../../components/UserFunctions';
import { connect } from 'react-redux';
import Pagination from './../Pagination'
import { getAdClientFromAPI } from "../../actions/closeLoop/adClientActionCloseLoop"
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom'
import Breadcrumb from 'react-bootstrap/Breadcrumb'


class CloseLoopViewAdClient extends Component {
  constructor(props) {
    super(props)


    this.state = {
      ad_client_details: []
    }
  }



  componentDidMount() {
    document.getElementsByClassName('print')[0].style.visibility = 'hidden';
    document.getElementsByClassName('download')[0].style.visibility = 'hidden';

    getAllAdClientsCloseLoop(1).then(res => {
      console.log(res)
      if (res.data) {
        this.props.dispatch(getAdClientFromAPI(res))
        console.log("res -->", res.data)
        this.setState({
          ad_client_details: res.data
        })
      }
      else {
        this.props.dispatch(getAdClientFromAPI({ data: [], current_page: 0, pages: [] }))
      }
    })
  }

  render() {
    const customStyles = {
      rows: {
        style: {
          minHeight: '72px',
          backgroundColor: "#C7C9FF",
        }
      },
      headCells: {
        style: {
          fontSize: "1rem",
          backgroundColor: "white",
          padding: ".75rem",
          verticalAlign: "top",
          borderTop: "1px solid #e9ecef",
          borderBottom: "5px solid #753DFF",
          justifyContent: "center"
        },
      },
      cells: {
        style: {
          fontSize: "1rem",
          textAlign: "center",
          verticalAlign: "top",
          borderTop: "5px solid white",
          justifyContent: "center"
        },
      },
    };

    const columns =
      [{
        name: 'Ad client ID',
        selector: 'session_id',
        sortable: true,
        cell: row => <div style={{ flexWrap: 'wrap' }}>{row.session_id}</div>
      },
      {
        name: 'Ad client Name',
        selector: 'name',
        sortable: true,
        cell: row => <div style={{ alignContent: "center" }}>{row.name}</div>
      },
      {
        name: 'UUID',
        selector: 'session_uuid',
        sortable: true,
        cell: row => <div style={{ alignContent: "center" }}>{row.session_uuid}</div>
      },
      {
        name: 'Updated At',
        selector: 'updated_at',
        sortable: true,
      }];
    const data = this.props.adClientData
    const tableData = {
      columns,
      data,
    };
    console.log("ad client", this.props.adClientData)
    console.log("dataaa", data)

    return (
      <div data-test="adViewComponent" className="container-fluid">
        <Breadcrumb>
          <Breadcrumb.Item href="">
            <Link to='navigate_new'>Home</Link></Breadcrumb.Item>
          <Breadcrumb.Item href="">
            <Link to='/welcome'>Welcome</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item href="" > <Link to='/close_loop'>Close loop</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item href="/close_loop_ad_client_listings" active >
            AD Client Viewer
          </Breadcrumb.Item>
        </Breadcrumb>
        <div className="row">
          <div className="col mt-5 mx-auto">
            <div className="card" style={{ backgroundColor: "white" }}>
              <div className="card">
                <h1 className="card-header" style={{ color: "white", fontSize: "100% !important", backgroundColor: "#757AF7" }}> AD Client Viewer</h1>
              </div>
              <div className="card-body">
                <DataTableExtensions
                  {...tableData}>
                  <DataTable
                    className="dataTables_wrapper"
                    columns={columns}
                    customStyles={customStyles}
                    data={data}
                    defaultSortField="id"
                    defaultSortAsc={false}
                    //  pagination
                    setFilter
                  >
                  </DataTable>
                </DataTableExtensions>

              </div>
            </div>
            <div>
              {this.props.adClientData.length > 0 ?
                <Pagination
                  currentPage={this.props.currentPage}
                  pages={this.props.pages}
                  getApiInfo={getAllAdClientsCloseLoop}
                  action={getAdClientFromAPI}
                />
                : undefined}
            </div>

          </div>
        </div>
      </div>
    )
  }
}

CloseLoopViewAdClient.propTypes = {
  dispatch: PropTypes.func,
  currentPage: PropTypes.number,
  pages: PropTypes.array,
  adClientData: PropTypes.array
}

const mapStateToProps = (state) => {
  return {
    adClientData: state.adClientCloseLoop.adClientData,
    currentPage: state.adClientCloseLoop.currentPage,
    pages: state.adClientCloseLoop.pages
  }
}

CloseLoopViewAdClient.propTypes = {
  dispatch: PropTypes.func
};

export default connect(mapStateToProps)(CloseLoopViewAdClient);
